<template>
  <!-- 营收监控 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">营收监控</span>
    </div>
    <div class="dataWarp">
      <div class="dataItem">
        <div class="xuanfu">{{ model.seeRate }}%</div>
        <liquidFill :data="1"></liquidFill>
        <span>水表抄见率</span>
      </div>
      <div class="dataItem">
        <div class="xuanfu">{{ model.finishingRate }}%</div>
        <liquidFill :data="1"></liquidFill>
        <span>抄表完成率</span>
      </div>
      <div class="dataItem">
        <div class="xuanfu">{{ model.recoveryRate }}%</div>
        <liquidFill :data="1"></liquidFill>
        <span>水费回收率</span>
      </div>
    </div>
  </div>
</template>

<script>
import liquidFill from './liquidFill'
import { getUUID } from '../../../utils/util'
export default {
  name: 'MaintenanceIndex',
  components: {
    liquidFill
  },
  data () {
    return {
      model: {},
      id: getUUID()
    }
  },
  created () {

  },
  beforeDestroy () {},
  mounted () {
    this.getEchartData()
  },
  methods: {
    getEchartData () {
        this.$http.get('/pipe-network/water_company_indicators/page').then(res => {
        this.model = res.data.list[0]
      //    this.dataList=[
      //   {
      //     data: model.seeRate,
      //     title: '水表抄见率'
      //   },
      //   {
      //    data: model.finishingRate,
      //     title: '抄表完成率'
      //   },
      //   {
      //   data: model.recoveryRate,
      //     title: '水费回收率'
      //   }
      // ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 382px;
  width: 376px;
  background: url(~@/assets/myImg/box-04.png) no-repeat;
  background-size: cover;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }
  .dataWarp {
    width: 100%;
    height: 342px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    top:27px;
    flex-direction: column;
    justify-content: space-around;
    .dataItem {
      width: 100%;
      height: 114px;
      display: flex;
      flex-direction: row;
      padding-left: 10px;
      // justify-content: space-around;
      align-items: center;
      .xuanfu {
        left: 13.5%;
        position: absolute;
        z-index: 1000;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 31px;
        font-weight: 600;
      }
      span {
        display: block;
        margin-left: 51px;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #10c0ff;
        font-weight: 400;
      }
    }
  }
}
</style>
